import { render, staticRenderFns } from "./solutionSummary.vue?vue&type=template&id=ba63ef16&scoped=true&"
import script from "./solutionSummary.vue?vue&type=script&lang=js&"
export * from "./solutionSummary.vue?vue&type=script&lang=js&"
import style0 from "./solutionSummary.vue?vue&type=style&index=0&id=ba63ef16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba63ef16",
  null
  
)

export default component.exports
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QVirtualScroll,QCard,QItem,QItemSection,QItemLabel,QBtn,QScrollArea,QSkeleton,QCheckbox});qInstall(component, 'directives', {Ripple});
